import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {Conjunction} from './'
import * as FeedfilterActions from '../../actions/FeedfilterActions'

export function Feedfilter(props){
    const rules = useSelector((state) => state.feedfilter.rules);
    const dispatch = useDispatch();

    let style = {};

    useEffect(() => {
        if(typeof props.rules !== 'undefined' && props.rules !== null)
            dispatch(FeedfilterActions.set_rules(props.rules));
        else
            dispatch(FeedfilterActions.set_rules(null));
    }, [props.rules]);

    if(typeof props.marketTypeHasChanged !== false && props.marketTypeHasChanged)
        style['paddingTop'] = '2em';

    return (
        <div style={{
				position: 'relative',
				display: 'flex',
				flexDirection: 'column',
				flexGrow: 1
			}}>
            <ul style={{
                listStyleType: 'none'
            }}>
                <Conjunction type="and" conditions={rules.children} />
            </ul>
        </div>
    )
}